import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { auth } from '@/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { isLoggedInSelector } from '@/features/auth/slice';
import routes from '@/constants/routes';

const PrivateRoutes = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const { pathname } = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user: any) => {
      if (!user) {
        navigate(routes.login, {
          state: { prevPage: pathname ?? '/comercios' },
        });
      }
    });

    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  if (!isLoggedIn) return null;

  return <Outlet />;
};

export default PrivateRoutes;
